import { Popover, PopoverTrigger, PopoverContent } from "../../popover";
import MagnifyingGlass from "../../../assets/icons/magnifying-glass-small-gray.svg";
import { DatePickerV3 } from "../../date-picker-v3";
import { Button } from "../../button";
import TableFilterState from "./table-filter-state";

type PopoverDateFilterProps<T = any> = {
  filterState: TableFilterState<T>;
  placeholder?: string | null;
  title?: string | null;
  description?: string | null;
  isOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
};

const PopoverDateFilter = <T extends Record<string, any>> ({
  filterState,
  placeholder,
  title,
  description,
  isOpen = false,
  onOpenChange
}: PopoverDateFilterProps<T>) => {
  // Check if filter has value
  const hasValue = filterState.filter[filterState.filterKey] && filterState.filter[filterState.filterKey].trim() !== '';

  // Use controlled state if provided, otherwise use internal logic
  const controlledOpen = isOpen !== undefined ? isOpen : (hasValue || false);
  const controlledOnOpenChange = onOpenChange || (() => {});

  const handleOpenChange = (newOpen: boolean) => {
    controlledOnOpenChange(newOpen);
  };

  const currentValue = filterState.filter[filterState.filterKey];
  const dateValue = currentValue ? new Date(currentValue) : undefined;

  const handleDateChange = (date: Date | undefined) => {
    // Format date to YYYY-MM-DD string format
    const formattedDate = date ? date.toLocaleDateString('en-CA') : '';
    filterState.setFilter(prev => ({
      ...prev,
      [filterState.filterKey]: formattedDate,
    }));
  };

  return (
    <Popover open={controlledOpen} onOpenChange={handleOpenChange}>
      <PopoverTrigger asChild>
        <img className="ml-2 w-3 cursor-pointer" src={MagnifyingGlass} alt="Search" />
      </PopoverTrigger>
      <PopoverContent className="w-auto p-3">
        <div className="space-y-3">
          {title && (
            <span className="block my-[10px] mx-[5px] text-xs text-[#6A7282]">
              {title}
            </span>
          )}
          <DatePickerV3
            value={dateValue}
            onChange={handleDateChange}
            placeholder={placeholder || "Pick a date"}
            className="w-full"
          />
          <div className="flex justify-end">
            <Button
              variant="outline"
              size="sm"
              onClick={() => {
                filterState.setFilter(prev => ({
                  ...prev,
                  [filterState.filterKey]: '',
                }));
              }}
              className="text-xs"
            >
              Clear Filter
            </Button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default PopoverDateFilter;
